module.exports = __webpack_public_path__ + "static/media/acompanhar-tecnico-branco.744b25ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/acompanhar-tecnico-branco.svg
// module id = 2838
// module chunks = 0